import React, { useEffect, useRef, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Menu } from 'primereact/menu';
import { fetchUserInfo, fetchUserCompanyInfo, fetchSwitchableAccounts, switchAccount, switchBack } from '../../Redux/Actions/userProfile';
import { selectLoggedInUserInfo, selectLoggedInUserCompany, selectSwitchableAccounts } from '../../Redux/Selectors/profile';
import { selectBrandsConfig } from '../../Redux/Selectors/brand';
import { getItems, getFilteredItems, handleLogout } from '../Header/header-utils';
import { setIsformDirty } from '../../Redux/Actions/common/form';
import { getIsFormDirty } from '../../Redux/Selectors/formState';
import { APP_URLS } from '../../constants/urlConstants';
import SwitchAccountDialog from '../Header/SwitchAccountDialog';
import ConfirmRouteChange from '../ConfirmRouteChange';
import Banner from '../Banner';
import ToastContainer from '../../containers/Notification/ToastContainer';
import IMG_DEFAULT_PROFILE from '../../images/default_user_profile.jpg';
import './SideNav.css';

/* Icons for each nav item (SVG paths, Feather-style) */
const NAV_ICONS = {
  Dashboard: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  Customer:  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Markup:    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  Users:     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  Cards:     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>,
  Reporting: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  Transactions: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>,
  'Daily Rates': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Invoices:  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>,
};

const SideNav = (props) => {
  const {
    history, isFormDirty, setIsformDirty,
    loggedInUserInfo, fetchUserInfo,
    loggedInUserCompany, fetchUserCompanyInfo,
    switchableAccounts, switchBack, brandConfig,
  } = props;

  const location = useLocation();
  const [logoImg, setLogoImg] = useState('');
  const [firstName, setFirstName] = useState('');
  const [profileImg, setProfileImg] = useState(IMG_DEFAULT_PROFILE);
  const [isAccountDialogVisible, showAccountsDialog] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const menuRef = useRef(null);
  const access = JSON.parse(localStorage.getItem('menuAccess'));

  useEffect(() => { fetchUserCompanyInfo(); fetchUserInfo(); }, []);

  useEffect(() => {
    if (loggedInUserCompany) {
      setLogoImg(loggedInUserCompany.profile_img || brandConfig?.config?.logo);
    }
  }, [loggedInUserCompany]);

  useEffect(() => {
    if (loggedInUserInfo) {
      setFirstName(loggedInUserInfo.first || '');
      setProfileImg(loggedInUserInfo.profile_img || IMG_DEFAULT_PROFILE);
    }
  }, [loggedInUserInfo]);

  const goToDashboard = () => history.push(APP_URLS.DASHBOARD.HOME);
  const fetchSwitchableAccountsFn = () => { props.fetchSwitchableAccounts(); showAccountsDialog(true); };
  const [items, endItems] = getItems(access, history, loggedInUserInfo, goToDashboard, handleLogout, fetchSwitchableAccountsFn);
  const navItems = getFilteredItems(items);

  /* Derive active route label */
  const activeLabel = navItems.find(item => {
    if (item.label === 'Dashboard') return location.pathname === '/Dashboard';
    if (item.label === 'Customer') return location.pathname.startsWith('/customer') && !location.pathname.startsWith('/customer-markup');
    if (item.label === 'Markup') return location.pathname.startsWith('/customer-markup');
    if (item.label === 'Users') return location.pathname.startsWith('/user');
    if (item.label === 'Cards') return location.pathname.startsWith('/manager');
    if (item.label === 'Reporting') return location.pathname.startsWith('/reporting');
    if (item.label === 'Transactions') return location.pathname.startsWith('/transactions');
    if (item.label === 'Daily Rates') return location.pathname.startsWith('/dailyrates');
    if (item.label === 'Invoices') return location.pathname.startsWith('/invoices');
    return false;
  })?.label;

  const showBanner = () => JSON.parse(sessionStorage.getItem("switchAccountBanner"));
  const ctaProps = { ctaText: "Switch back", cta: () => { switchBack(); } };

  return (
    <>
      <ToastContainer />
      <ConfirmRouteChange isFormDirty={isFormDirty} history={history} setIsformDirty={setIsformDirty} />
      {isAccountDialogVisible && (
        <SwitchAccountDialog
          accounts={switchableAccounts}
          showDialog={showAccountsDialog}
          switchAccount={(code) => props.switchAccount(code)}
        />
      )}
      {showBanner() && <Banner message="Operating from switched account" {...ctaProps} />}

      {/* Hamburger — visible on mobile only */}
      <button className="sidenav-hamburger" onClick={() => setNavOpen(true)} aria-label="Open menu">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
      </button>

      {/* Overlay — closes nav on mobile tap-outside */}
      <div
        className={`sidenav-overlay${navOpen ? ' sidenav-overlay--visible' : ''}`}
        onClick={() => setNavOpen(false)}
      />

      <nav className={`sidenav${navOpen ? ' sidenav--open' : ''}`}>
        {/* Logo */}
        <div className="sidenav-logo" onClick={() => { goToDashboard(); setNavOpen(false); }}>
          <img
            src={logoImg}
            onError={(e) => { e.target.src = brandConfig?.config?.logo; }}
            alt="logo"
            className="sidenav-logo-img"
          />
        </div>

        {/* Nav items */}
        <ul className="sidenav-items">
          {navItems.map((item) => (
            <li
              key={item.label}
              className={`sidenav-item${activeLabel === item.label ? ' sidenav-item--active' : ''}`}
              onClick={() => { item.command(); setNavOpen(false); }}
              title={item.label}
            >
              <span className="sidenav-icon">{NAV_ICONS[item.label]}</span>
              <span className="sidenav-label">{item.label}</span>
            </li>
          ))}
        </ul>

        {/* User profile at bottom */}
        <div className="sidenav-footer">
          <Menu model={endItems} popup ref={menuRef} id="sidenav_popup" />
          <div className="sidenav-user" onClick={(e) => menuRef.current.toggle(e)}>
            <img src={profileImg} alt="user" className="sidenav-avatar" />
            <span className="sidenav-username">{firstName}</span>
          </div>
        </div>
      </nav>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  loggedInUserInfo: selectLoggedInUserInfo(state),
  loggedInUserCompany: selectLoggedInUserCompany(state),
  switchableAccounts: selectSwitchableAccounts(state),
  isFormDirty: getIsFormDirty(state),
  brandConfig: selectBrandsConfig(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserInfo: () => dispatch(fetchUserInfo()),
  fetchUserCompanyInfo: () => dispatch(fetchUserCompanyInfo()),
  fetchSwitchableAccounts: () => dispatch(fetchSwitchableAccounts()),
  setIsformDirty: (dirty) => dispatch(setIsformDirty(dirty)),
  switchAccount: (code) => dispatch(switchAccount(code)),
  switchBack: () => dispatch(switchBack()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SideNav));
